<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 26 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_530_20069)">
      <path
        d="M10.123 22C15.7138 22 20.246 17.5717 20.246 12.1091C20.246 6.64655 15.7138 2.21826 10.123 2.21826C4.53221 2.21826 0 6.64655 0 12.1091C0 17.5717 4.53221 22 10.123 22Z"
        fill="url(#paint0_linear_530_20069)"
      />
      <path
        d="M9.89032 13.0561L26.0039 13.1418C26.0162 10.5487 25.3736 7.99263 24.1329 5.70022C22.8923 3.40782 21.0919 1.44989 18.8915 0L9.89032 13.0561Z"
        fill="url(#paint1_linear_530_20069)"
      />
      <path
        d="M10.0047 13.1493L22.3026 8.07521C21.2801 5.71424 19.5684 3.69989 17.3813 2.28365C15.1942 0.867401 12.6285 0.112018 10.0047 0.111816V13.1493Z"
        fill="url(#paint2_linear_530_20069)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_530_20069"
        x1="16.2281"
        y1="18.2122"
        x2="3.0112"
        y2="4.36487"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A7FF" />
        <stop offset="1" stop-color="#00A7FF" stop-opacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_530_20069"
        x1="21.2267"
        y1="17.6082"
        x2="17.6536"
        y2="10.298"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#177AF0" />
        <stop offset="0.99" stop-color="#177AF0" stop-opacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_530_20069"
        x1="17.9833"
        y1="10.204"
        x2="9.70709"
        y2="5.15492"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#177AF0" />
        <stop offset="0.99" stop-color="#177AF0" stop-opacity="0.5" />
      </linearGradient>
      <clipPath id="clip0_530_20069">
        <rect width="26" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'DWHIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
